module.exports = __webpack_public_path__ + "static/koji-8d4f2d50f583275c23ce3927f2ef4322.jpg";